import { Location, PlatformLocation, isPlatformBrowser } from "@angular/common";
import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { LOCAL_STORAGE } from "@ng-toolkit/universal";
import { TranslateService } from "@ngx-translate/core";
import { Lightbox } from "ngx-lightbox";
import { AppComponent } from "src/app/app.component";
import { FormData, Person } from "src/app/models/formData";
import { CountCartService } from "src/app/services/count-cart.service";
import { FormDataService } from "src/app/services/form-data.service";
import { RestService } from "src/app/services/rest.service";
import { ServiceSEOService } from "src/app/services/service-seo.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-payment-review",
  templateUrl: "./payment-review.component.html",
  styleUrls: ["./payment-review.component.css"],
})
export class PaymentReviewComponent implements OnInit {
  node_static_url = environment.node_static_url;
  person: Person;
  mDataArrayPerson: any[];
  invoice_uuid = "";
  total = 0;
  countTotal = 0;
  isEmptyCart = false;
  timeLeft = 0;
  interval: any;
  model: any = {};
  isCheckOut = false;
  @Input() formData: FormData;
  @ViewChild("bcelForm", { static: false }) testFormEl;
  mPaymentMethod: any[];
  selected_payment_method: string;
  selected_payment_active: string;
  selected_payment_method_text: string;
  _albumsPhoto = [];
  _albumsPassport = [];
  _albumsCover = [];
  _albumProoFile = [];
  proofileCol: boolean = false;
  data = {
    session_id: "",
    input_id: "",
    input_value: "",
  };
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private app: AppComponent,
    private router: Router,

    private rest: RestService,
    private formDataService: FormDataService,
    private countIncart: CountCartService,
    private _lightbox: Lightbox,
    private modalService: NgbModal,
    @Inject(LOCAL_STORAGE) private localStorage: any
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.person = this.formDataService.getFormData();
    let authInfo: any = null;
    try {
      const raw = localStorage.getItem(environment.localAuthenInfo);
      if (raw && raw !== "null" && raw !== "undefined") {
        authInfo = JSON.parse(raw);
      }
    } catch (e) {
      console.warn("Failed to parse localAuthenInfo in payment-review:", e);
    }
    if (authInfo && authInfo.token) {
      this.person.token = authInfo.token;
      this.getData();
    } else {
      this.router.navigate(["/apply"]);
    }
  }

  getData() {
    this.person.currentActiveForm = "3";
    this.onGetPersonInfo();
    this.countIncart.funcCountCart();
  }
  addMorePerson() {
    this.formData = this.formDataService.resetFormData();
    this.router.navigate(["/application"]);
    this.data.session_id = this.localStorage.getItem("session_id");
    this.data.input_id = "addMorePeople";
    this.data.input_value = "add_more_people";

    // this.rest.updateUserSession(this.data).subscribe((res) => {
    //   console.log("Result Update Session when focus input:", res);
    // });
  }

  calculateTotal() {
    this.countTotal = this.mDataArrayPerson.length;
  }

  backToCart(event: any) {
    this.data.session_id = this.localStorage.getItem("session_id");
    this.data.input_id = event.target.id;
    this.data.input_value = "back_to_cart";
    // this.rest.updateUserSession(this.data).subscribe((res) => {
    //   console.log("Result Update Session when focus input:", res);
    // });
    this.router.navigate(["/cart"]);
  }

  open(content) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.startTimer();
    this.modalService.open(content, { centered: true });
  }
  openPhoto(index: number): void {
    if (isPlatformBrowser(this.platformId)) {
      this._lightbox.open(this._albumsPhoto, index, { centerVertically: true });
    }
  }
  openPassport(index: number): void {
    if (isPlatformBrowser(this.platformId)) {
      this._lightbox.open(this._albumsPassport, index, {
        centerVertically: true,
      });
    }
  }
  openCover(index: number): void {
    if (isPlatformBrowser(this.platformId)) {
      this._lightbox.open(this._albumsCover, index, { centerVertically: true });
    }
  }
  closeImgPreview(): void {
    this._lightbox.close();
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.timeLeft += 20;
      if (this.timeLeft === 100) {
        clearInterval(this.interval);
        this.modalService.dismissAll();
        this.countIncart.funcCountCart();
        this.onGetPersonInfo();
      }
    }, 1000);
  }

  onGetPersonInfo() {
    this.rest.getPersonForPayment().subscribe((result) => {
      if (result.length > 0) {
        this.mDataArrayPerson = result;
        this.calculateTotal();
        this.invoice_uuid = result[0].invoice_uuid;
        let m_total = 0;
        for (let i = 0; i < result.length; i++) {
          m_total += result[i].price;
        }
        this.total = Math.round(m_total * 100) / 100 || 0;
      } else {
        this.mDataArrayPerson = result;
        this.isEmptyCart = true;
        this.total = 0;
      }
      this.onLoadImage(result);
    });
  }

  onLoadImage(person: Array<any>) {
    for (let i = 0; i < person.length; i++) {
      if (person[i].version == "2") {
        this.rest.getBase64ImageService(person[i].photo_name, "photo").subscribe((result) => {
          this._albumsPhoto.push({
            src: result["photo_name"],
            caption: "Photo "
          });
          this.mDataArrayPerson[i].photo_name = result["photo_name"];
        })
        this.rest.getBase64ImageService(person[i].passport_name, "passport").subscribe((result) => {
          this._albumsPassport.push({
            src: result["passport_name"],
            caption: "Passport "
          });
          this.mDataArrayPerson[i].passport_name = result["passport_name"];
        })
      } else {
        this.mDataArrayPerson[i].photo_name = person[i].photo_name;
        this._albumsPhoto.push({
          src: person[i].photo_name,
          caption: "Photo "
        });
        this.mDataArrayPerson[i].passport_name = person[i].passport_name;
        this._albumsPassport.push({
          src: person[i].passport_name,
          caption: "Passport "
        });
      }
    }
  }
}
